import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/common/services/api.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { OfferService } from '../../offer/offer.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'portal-quote',
    templateUrl: './portal-quote.component.html'
})
export class PortalQuoteComponent implements OnInit {

    public quotes: any[] = [];
    public right_side_bar: boolean;
    constructor(public translate: TranslateService,
                public apiService: ApiService,
                private toastrService: ToastrService,
                private offerService: OfferService,
                private router: Router,
                private route: ActivatedRoute) { }
    ngOnInit() {
        this.getQuotes();
    }

    getQuotes() {
        var model = {
            PageSize: 1000,
            SortOrder: 'Desc',
            SortField: '',
            IsOfferOnlyInd: 'Y'
        };
        this.apiService.post("API/WebUserApi/Policies", model).subscribe((result: any) => {
            for (var policyKey in result.rows) {
                if (result.rows[policyKey].PolStatusCde == 4) {
                    this.quotes.push(result.rows[policyKey]);
                }
            }

            if (this.quotes.length == 0) {
                this.toastrService.error(this.translate.instant("No records to be viewed"));
            }
        });
    }
}
